import { createFileRoute } from "@tanstack/react-router";
import { KundestøttePage } from "@/features/landing/KundestøttePage";

export const Route = createFileRoute("/_public/_landing/kundestøtte")({
  component: KundestøttePage,
  head: () => ({
    meta: [
      {
        title: "Kundestøtte | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
